import { useEffect, useState } from "react";

type AllowanceItem = {
  name: string;
  amount: number;
  exempt: string;
};

type ComputaxStylePayrollForm = {
  employeeName: string;
  employeeId: string;
  email: string;
  phone: string;
  department: string;
  joiningDate: string;
  designation: string;
  address1: string;
  address2: string;
  pincode: string;
  state: string;
  country: string;
  basicPay: string;
  da: string;
  commission: string;
  leaveEncashment: string;
  transport: string;
  entertainment: string;
  bonus: string;
  profTax: string;
  taxPaidByEmployer: string;
  NetSalary: string;
  pf: string;
  esic: string;
  ctcValue: string;
  isPensioner: boolean;
  hra: string;
  isHandicap: boolean;
  month: string;
  year: string;
  allowances: AllowanceItem[];
};


const ComputaxStylePayrollForm = () => {
  const [form, setForm] = useState<ComputaxStylePayrollForm>({
    employeeName: "",
    employeeId: "",
    email: "",
    phone: "",
    department: "",
    joiningDate: "",
    designation: "",
    address1: "",
    address2: "",
    pincode: "",
    state: "",
    country: "India",
    basicPay: "",
    da: "",
    commission: "",
    leaveEncashment: "",
    transport: "",
    entertainment: "",
    bonus: "",
    profTax: "",
    taxPaidByEmployer: "",
    NetSalary: "",
    pf: "",
    esic: "",
    month: "",
    year: "",
    ctcValue: "",
    isPensioner: false,
    hra: "0",
    isHandicap: false,
    allowances: [],
  });

  const handleAddAllowance = (index: number, field: string, value: string) => {
    setForm((prev) => {
      const newAllowances = [...prev.allowances];
      newAllowances[index] = {
        ...newAllowances[index],
        [field]: field === "amount" ? Number(value) : value,
      };
      return { ...prev, allowances: newAllowances };
    });
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [ctcEnabled, setCtcEnabled] = useState(false);
  const [ctcValue, setCtcValue] = useState(0);
  // const [allowanceItems, setAllowanceItems] = useState<AllowanceItem[]>([
  //   { name: "", amount: 0, exempt: "" },
  // ]);


  const toggleDropdown = () => setShowOptions(!showOptions);

  useEffect(() => {
    const totalEarnings =
      Number(form.basicPay) +
      Number(form.da) +
      Number(form.commission) +
      Number(form.hra) +
      Number(form.leaveEncashment) +
      Number(form.transport) +
      Number(form.entertainment) +
      Number(form.bonus);

    const totalAllowance = form.allowances.reduce(
      (acc, item) => acc + Number(item.amount || 0),
      0
    );

    const totalDeductions =
      Number(form.profTax) +
      Number(form.taxPaidByEmployer) +
      Number(form.pf) +
      Number(form.esic);

    const netSalary = (totalEarnings + totalAllowance - totalDeductions).toFixed(2);

    setForm((prev) => ({ ...prev, NetSalary: netSalary }));
  }, [
    form.basicPay,
    form.da,
    form.commission,
    form.leaveEncashment,
    form.transport,
    form.entertainment,
    form.bonus,
    form.profTax,
    form.taxPaidByEmployer,
    form.pf,
    form.esic,
    form.allowances
  ]);

  useEffect(() => {
  if (!ctcEnabled || !ctcValue) return;

  const monthlyCTC = ctcValue / 12;
  const basicPay = +(monthlyCTC * 0.5).toFixed(2);
  const hra = +(basicPay * 0.5).toFixed(2);
  const pf = +(basicPay * 0.12).toFixed(2);
  const esic = +(basicPay * 0.0075).toFixed(2);

  const autoCalculatedFields = {
    basicPay: basicPay.toString(),
    hra: hra.toString(),
    pf: pf.toString(),
    esic: esic.toString(),
  };

  const zeroedFields = [
    "da",
    "bonus",
    "transport",
    "entertainment",
    "commission",
    "leaveEncashment",
    "taxPaidByEmployer",
    "profTax",
  ].reduce((acc, key) => ({ ...acc, [key]: "0" }), {});

    setForm((prev) => ({
      ...prev,
      ...autoCalculatedFields,
      ...zeroedFields,
    }));
  }, [ctcEnabled, ctcValue]);


  useEffect(() => {
    const fetchSuggestions = async () => {
      if (searchTerm.length > 2) {
        try {
          const token = localStorage.getItem("accessToken");
          const res = await fetch(`/api/employees?search=${searchTerm}`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
          const data = await res.json();
          setSuggestions(data.employees);
        } catch (err) {
          console.error("Failed to fetch employee suggestions:", err);
          setSuggestions([]);
        }
      } else {
        setSuggestions([]);
      }
    };
    fetchSuggestions();
  }, [searchTerm]);


  
  const handleEmployeeSelect = (emp) => {
    setForm((prev) => ({
      ...prev,
      employeeName: emp.name,
      employee_id: emp._id,
      email: emp.email,
      phone: emp.phone,
      department: emp.department,
      designation: emp.designation,
      joiningDate: emp.dateOfJoining,
      address1: emp.address1,
      address2: emp.address2,
      pincode: emp.pincode,
      state: emp.state,
      country: emp.country || "India",
    }));
    setSearchTerm(emp.name);
    setSuggestions([]);
  };

  const handleSubmitSalary = async () => {
  try {
    const response = await fetch("/api/payroll-records", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });

    const result = await response.json();

    if (response.ok) {
      alert("Salary submitted successfully!");
      // fetchPayrollRecords(); 
    } else {
      alert(result.detail || "Failed to submit salary.");
    }
  } catch (error) {
    console.error("Submit error:", error);
    alert("Error submitting salary.");
  }
};


  return (

     <div className="max-w-6xl mx-auto p-4 space-y-6">
      {/* Employee Search */}
      <div>
        <input
          type="text"
          className="border p-2 w-full"
          placeholder="Search employee by name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {suggestions.length > 0 && (
          <ul className="bg-white border shadow rounded mt-1 max-h-60 overflow-y-auto z-50">
            {suggestions.map((emp) => (
              <li
                key={emp.employee_id}
                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                onClick={() => handleEmployeeSelect(emp)}
              >
                {emp.name} ({emp.employee_id})
              </li>
            ))}
          </ul>
        )}
      </div>
        

    <form className="max-w-6xl mx-auto p-6 bg-white shadow rounded-lg space-y-6 text-sm">
      <h2 className="text-lg font-bold">Employer Details</h2>
      <div className="grid grid-cols-3 gap-4">
        <input
          className="border p-2"
          placeholder="Employee Name"
          value={form.employeeName}
          onChange={(e) => setForm({ ...form, employeeName: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Employee ID"
          value={form.employeeId}
          onChange={(e) => setForm({ ...form, employeeId: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Joining Date"
          type="date"
          value={form.joiningDate}
          onChange={(e) => setForm({ ...form, joiningDate: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Phone No."
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Department"
          value={form.department}
          onChange={(e) => setForm({ ...form, department: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Designation"
          value={form.designation}
          onChange={(e) => setForm({ ...form, designation: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Address 1"
          value={form.address1}
          onChange={(e) => setForm({ ...form, address1: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Address 2"
          value={form.address2}
          onChange={(e) => setForm({ ...form, address2: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Pincode"
          value={form.pincode}
          onChange={(e) => setForm({ ...form, pincode: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="State"
          value={form.state}
          onChange={(e) => setForm({ ...form, state: e.target.value })}
        />
        <input
          className="border p-2"
          placeholder="Country"
          value={form.country}
          onChange={(e) => setForm({ ...form, country: e.target.value })}

        />
        <select
            className="border p-2"
            value={form.month}
            onChange={(e) => setForm({ ...form, month: e.target.value })}
          >
            <option value="">Select Month</option>
            <option value="January">January</option>
            <option value="February">February</option>
            <option value="March">March</option>
            <option value="April">April</option>
            <option value="May">May</option>
            <option value="June">June</option>
            <option value="July">July</option>
            <option value="August">August</option>
            <option value="September">September</option>
            <option value="October">October</option>
            <option value="November">November</option>
            <option value="December">December</option>
          </select>

          <input
            type="number"
            className="border p-2"
            placeholder="Year"
            value={form.year}
            onChange={(e) => setForm({ ...form, year: e.target.value })}
          />

      </div>

        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={ctcEnabled}
            onChange={() => setCtcEnabled(!ctcEnabled)}
          />
          <label>Calculate CTC</label>

          {ctcEnabled && (
            <input
              type="number"
              placeholder="Enter Annual CTC"
              value={ctcValue}
              className="border p-2 w-48"
              onChange={(e) => setCtcValue(parseFloat(e.target.value ||"0"))}
            />
          )}
        </div>

      
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

  {/* Earnings Card */}
  <div className="border p-4 rounded-xl shadow-sm">
    <h2 className="text-lg font-semibold mb-4">Earnings</h2>
    <div className="space-y-4">
      {([
        { label: "Basic Pay", key: "basicPay" },
        { label: "Dearness Allowance", key: "da" },
        { label: "Bonus", key: "bonus" },
        { label: "Transport Allowance", key: "transport" },
        { label: "Entertainment Allowance", key: "entertainment" },
        { label: "Commission", key: "commission" },
        { label: "Leave Encashment", key: "leaveEncashment" },
        { label: "HRA", key: "hra" },
      ] as const).map(({ label, key }) => (
        <div key={key}>
          <label className="block mb-1 text-sm font-medium">{label}</label>
          <input
            className="border p-2 w-full"
            placeholder={label}
            value={String(form[key as keyof ComputaxStylePayrollForm])}
            onChange={(e) =>
              setForm({ ...form, [key]: e.target.value } as ComputaxStylePayrollForm)
            }
          />
        </div>
      ))}
    </div>
  </div>

  {/* Deductions Card */}
  <div className="border p-4 rounded-xl shadow-sm">
    <h2 className="text-lg font-semibold mb-4">Deductions</h2>
    <div className="space-y-4">
      {[
        { label: "Professional Tax", key: "profTax" },
        { label: "Tax Paid by Employer", key: "taxPaidByEmployer" },
        { label: "Provident Fund (Auto)", key: "pf", readOnly: true },
        { label: "ESIC (Auto)", key: "esic", readOnly: true },
      ].map(({ label, key, readOnly }) => (
        <div key={key}>
          <label className="block mb-1 text-sm font-medium">{label}</label>
          <input
            className={`border p-2 w-full ${readOnly ? "bg-gray-100 text-gray-700" : ""}`}
            placeholder={label}
            value={form[key]}
            readOnly={readOnly}
            disabled={key === "esic"}
            onChange={(e) => !readOnly && setForm({ ...form, [key]: e.target.value })}
          />
        </div>
      ))}
    </div>
  </div>
</div>

{/* Net Salary Section */} 
<div className="mt-6">
  <label className="block mb-1 text-sm font-medium">Net Salary</label>
  <input
    className="border p-2 w-full"
    placeholder="Net Salary"
    value={form.NetSalary}
    onChange={(e) => setForm({ ...form, NetSalary: e.target.value })}
  />
</div>

        <div className="flex gap-4 items-center mt-4">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={form.isPensioner}
              onChange={() => setForm({ ...form, isPensioner: !form.isPensioner })}
            />
            Pensioner
          </label>
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={form.isHandicap}
              onChange={() => setForm({ ...form, isHandicap: !form.isHandicap })}
            />
            Handicap
          </label>
          
          <div className="relative ml-auto">
            <button
              type="button"
              onClick={toggleDropdown}
              className="bg-blue-600 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-700"
            >
              Allowance / Perquisite
            </button>

            {showOptions && (
              <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg border rounded-md z-50 max-h-80 overflow-y-auto">
                <div className="p-2 font-bold text-gray-700 border-b">PERQUISITES</div>
                <ul className="p-2 space-y-1">
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">A. Accomodation</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">V. Vehicle</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">M. Medical</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">L. Leave Travel Concession</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">F. Free Education</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">G. Gas, Electricity & Water</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">D. Domestic Servant</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">U. Manual Calculated Value</li>
                </ul>
                <div className="p-2 font-bold text-gray-700 border-t border-b">ALLOWANCES</div>
                <ul className="p-2 space-y-1">
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">H. H.R.A</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">C. Children Allowance</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">E. Employer Contribution To PF</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">I. Intrest Credited To PF</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">R. Arrear Salary</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">N. Advance Salary</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">O. Other Allowances</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">T. Terminal Benefits</li>
                  <li className="cursor-pointer hover:bg-gray-100 p-1 rounded">S. Employer Cont. To SuperAnnuation Fund</li>
                </ul>
              </div>
            )}
          </div>
        </div>

        <h2 className="text-lg font-bold mt-6">Other Allowances </h2>
        <table className="w-full text-sm border">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Allowance</th>
              <th className="border p-2">Received Amount</th>
              <th className="border p-2">Exempt</th>
            </tr>
          </thead>
          <tbody>
            {form.allowances.map((row, index) => (
              <tr key={index}>
                <td className="border p-2">
                  <input
                    className="w-full border p-1"
                    placeholder="Allowance name"
                    value={row.name}
                    onChange={(e) =>
                      handleAddAllowance(index, "name", e.target.value)
                    }
                  />
                </td>
                <td className="border p-2">
                  <input
                    className="w-full border p-1"
                    placeholder="Amount"
                    value={row.amount}
                    onChange={(e) =>
                      handleAddAllowance(index, "amount", e.target.value)
                    }
                  />
                </td>
                <td className="border p-2">
                  <input
                    className="w-full border p-1"
                    placeholder="Exempt"
                    value={row.exempt}
                    onChange={(e) =>
                      handleAddAllowance(index, "exempt", e.target.value)
                    }
                  />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button
        type="submit"
        onClick={handleSubmitSalary}
        className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Submit Salary
      </button>
    </form>
    </div>
  );
}

export default ComputaxStylePayrollForm;

